export const AMPLITUDE_PRODUCT_CLICKED = 'product_clicked' as const;

export const AMPLITUDE_PRODUCT_CLICKED_EVENT_ID = 70 as const;

export const GTM_EVENT_KEY = 'gtm.uniqueEventId' as const;
